//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, map, from, of, mergeMap } from 'rxjs';

import { Inject, Injectable, InjectionToken, Optional } from "@angular/core";
export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
@Injectable({
  providedIn: 'root'
})

export class Client {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  static authToken: string | null = null;

  constructor(
    private httpBackend: HttpBackend,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = new HttpClient(httpBackend);
    this.baseUrl = baseUrl ?? "";
  }

  static setAuthToken(token: string) {
    this.authToken = token;
    sessionStorage.setItem('oab-profile', token);
  }


  /**
   * @param accept_Language (optional) 
   * @param body (optional) 
   * @return Created
   */
  createAppointment(companyId: string, accept_Language: string | undefined, body: AppointmentRequest | undefined): Observable<string> {
    if (!companyId) throw new Error("The parameter 'companyId' must be defined.");
    const url_ = `${this.baseUrl}/api/Appointments/companies/${encodeURIComponent(companyId)}/appointments`;
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    const options_: RequestInit = {
      method: 'POST',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? 'en-US',
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body != null ? JSON.stringify(body) : undefined
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processCreateAppointment(res)));
  }


  protected processCreateAppointment(response: Response): Observable<any> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 201) {
      return from(response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : <any>null;
        return result201;
      }));
    }
    else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = resultData201 !== undefined ? resultData201 : <any>null;
        return result201;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as string);
  }

  /**
   * @param accept_Language (optional) 
   * @return OK
   */
  // removed auth-arg overload to use session-stored token

  /**
   * @param accept_Language (optional)
   * @return OK
   */
  CancelAppointment(companyId: string, appointmentId: string, accept_Language: string | undefined): Observable<any> {
    let url_ = this.baseUrl + "/api/Appointments/companies/{companyId}/appointments/{appointmentId}/cancel";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (appointmentId === undefined || appointmentId === null) throw new Error("The parameter 'appointmentId' must be defined.");
    url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'POST',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processCancelAppointment(res)));
  }

  protected processCancelAppointment(response: Response): Observable<AppointmentDetails> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as AppointmentDetails);
  }

  /**
   * @param accept_Language (optional) 
   * @return OK
   */

  getAppointment(companyId: string, appointmentId: string, accept_Language: string | undefined): Observable<AppointmentDetails> {
    let url_ = this.baseUrl + "/api/Appointments/companies/{companyId}/appointments/{appointmentId}";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (appointmentId === undefined || appointmentId === null) throw new Error("The parameter 'appointmentId' must be defined.");
    url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetAppointment(res)));
  }

  protected processGetAppointment(response: Response): Observable<AppointmentDetails> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AppointmentDetails.fromJS(resultData200);
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as AppointmentDetails);
  }
  
  getMakes(companyId: string, accept_Language: string | undefined): Observable<MakeDto[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/makes";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetMakes(res)));
  }

  protected processGetMakes(response: Response): Observable<MakeDto[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(MakeDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as MakeDto[]);
  }

  /**
   * @param accept_Language (optional) 
   * @return OK
   */
  getDepartments(companyId: string, accept_Language: string | undefined): Observable<DepartmentDto[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/departments";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetDepartments(res)));
  }

  protected processGetDepartments(response: Response): Observable<DepartmentDto[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DepartmentDto.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as DepartmentDto[]);
  }

  /**
   * @param locationId (optional) 
   * @param accept_Language (optional) 
   * @return OK
   */
  getResources(companyId: string, locationId: string | undefined, department:string | undefined,accept_Language: string | undefined): Observable<Resource[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/resources?"; 
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (department === undefined || department === null) throw new Error("The parameter 'department' must be defined.");
    url_ += "department=" + encodeURIComponent(department) + "&";
    if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined) url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetResources(res)));
  }

  protected processGetResources(response: Response): Observable<Resource[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(Resource.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as Resource[]);
  }

  /**
   * @param locationId (optional) 
   * @param accept_Language (optional) 
   * @return OK
   */
  getServices(companyId: string, locationId: string | undefined, accept_Language: string | undefined, department?: string, make?: string): Observable<Service[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/services?";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined) url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    if (department !== undefined) url_ += "department=" + encodeURIComponent("" + department) + "&";
    if (make !== undefined) url_ += "make=" + encodeURIComponent("" + make) + "&";
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetServices(res)));
  }

  protected processGetServices(response: Response): Observable<Service[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(Service.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as Service[]);
  }

  /**
   * @param accept_Language (optional) 
   * @return OK
   */
  getPaymentMethods(companyId: string, accept_Language: string | undefined): Observable<PaymentMethodsResponse[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/paymentmethods";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetPaymentMethods(res)));
  }

  protected processGetPaymentMethods(response: Response): Observable<PaymentMethodsResponse[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PaymentMethodsResponse.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return resultData200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as PaymentMethodsResponse[]);

  }

  /**
   * @param locationId (optional) 
   * @param accept_Language (optional) 
   * @param body (optional) 
   * @return OK
   */
  getTimeSlots(companyId: string, locationId: string | undefined, accept_Language: string | undefined, body: TimeslotRequest | undefined): Observable<Timeslot[]> {
    let url_ = this.baseUrl + "/api/Details/companies/{companyId}/timeslots?";
    const authToken = Client.authToken ?? sessionStorage.getItem('oab-profile');
    if (companyId === undefined || companyId === null) throw new Error("The parameter 'companyId' must be defined.");
    url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
    if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
    else if (locationId !== undefined) url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'POST',
      headers: {
        'Authorization': authToken ? `Bearer ${authToken}` : '',
        'Accept-Language': accept_Language ?? '',
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body != null ? JSON.stringify(body) : undefined
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processGetTimeSlots(res)));
  }

  protected processGetTimeSlots(response: Response): Observable<Timeslot[]> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(Timeslot.fromJS(item));
        }
        else {
          result200 = <any>null;
        }
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as Timeslot[]);
  }

  /**
   * @param token (optional) 
   * @param accept_Language (optional) 
   * @return OK
   */
  pageLoadDetails(token: string | undefined, accept_Language: string | undefined): Observable<LoginResponse> {
    let url_ = this.baseUrl + "/api/Login";
    url_ = url_.replace(/[?&]$/, "");
    const options_: RequestInit = {
      method: 'GET',
      headers: {
        'token': token ?? '',
        'Accept-Language': accept_Language ?? '',
        'Accept': 'application/json'
      }
    };
    return from(fetch(url_, options_)).pipe(mergeMap(res => this.processPageLoadDetails(res)));
  }

  protected processPageLoadDetails(response: Response): Observable<LoginResponse> {
    const status = response.status;
    let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
    if (status === 400) {
      return from(response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DmsProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 401) {
      return from(response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = DmsProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      }));
    } else if (status === 403) {
      return from(response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = DmsProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);
      }));
    } else if (status === 500) {
      return from(response.text().then((_responseText) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = DmsProblemDetails.fromJS(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status === 503) {
      return from(response.text().then((_responseText) => {
        let result503: any = null;
        let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result503 = DmsProblemDetails.fromJS(resultData503);
        return throwException("Service Unavailable", status, _responseText, _headers, result503);
      }));
    } else if (status === 200) {
      return from(response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LoginResponse.fromJS(resultData200);
        return result200;
      }));
    } else if (status !== 200 && status !== 204) {
      return from(response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any as LoginResponse);
  }
}

export class Customer implements ICustomer {
  name!: string;
  phone?: PhoneNumber;
  email?: Email;

  constructor(data?: ICustomer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.phone = _data["phone"] ? PhoneNumber.fromJS(_data["phone"]) : <any>undefined;
      this.email = _data["email"] ? Email.fromJS(_data["email"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Customer {
    data = typeof data === 'object' ? data : {};
    let result = new Customer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
    data["email"] = this.email ? this.email.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICustomer {
  name: string;
  phone?: PhoneNumber;
  email?: Email;
}

export class DataPrivacyConsent implements IDataPrivacyConsent {
  beneficiary?: string | undefined;
  purpose!: DataPrivacyPurpose;
  description?: string | undefined;
  expirationDate?: Date;
  createdOn!: Date;

  constructor(data?: IDataPrivacyConsent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.purpose = new DataPrivacyPurpose();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.beneficiary = _data["beneficiary"];
      this.purpose = _data["purpose"] ? DataPrivacyPurpose.fromJS(_data["purpose"]) : new DataPrivacyPurpose();
      this.description = _data["description"];
      this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
      this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): DataPrivacyConsent {
    data = typeof data === 'object' ? data : {};
    let result = new DataPrivacyConsent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["beneficiary"] = this.beneficiary;
    data["purpose"] = this.purpose ? this.purpose.toJSON() : <any>undefined;
    data["description"] = this.description;
    data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
    return data;
  }
}

export interface IDataPrivacyConsent {
  beneficiary?: string | undefined;
  purpose: DataPrivacyPurpose;
  description?: string | undefined;
  expirationDate?: Date;
  createdOn: Date;
}

export class DataPrivacyPurpose implements IDataPrivacyPurpose {
  type?: string | undefined;
  description?: string | undefined;
  communicationChannels?: CommunicationChannelType[] | undefined;

  constructor(data?: IDataPrivacyPurpose) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.description = _data["description"];
      if (Array.isArray(_data["communicationChannels"])) {
        this.communicationChannels = [] as any;
        for (let item of _data["communicationChannels"])
          this.communicationChannels!.push(item);
      }
    }
  }

  static fromJS(data: any): DataPrivacyPurpose {
    data = typeof data === 'object' ? data : {};
    let result = new DataPrivacyPurpose();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["description"] = this.description;
    if (Array.isArray(this.communicationChannels)) {
      data["communicationChannels"] = [];
      for (let item of this.communicationChannels)
        data["communicationChannels"].push(item);
    }
    return data;
  }
}

export interface IDataPrivacyPurpose {
  type?: string | undefined;
  description?: string | undefined;
  communicationChannels?: CommunicationChannelType[] | undefined;
}

export class Discount implements IDiscount {
  value?: number | undefined;
  percent?: number | undefined;

  constructor(data?: IDiscount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): Discount {
    data = typeof data === 'object' ? data : {};
    let result = new Discount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["percent"] = this.percent;
    return data;
  }
}

export interface IDiscount {
  value?: number | undefined;
  percent?: number | undefined;
}

export class DocumentStatus implements IDocumentStatus {
  code?: string | undefined;
  description?: string | undefined;

  constructor(data?: IDocumentStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): DocumentStatus {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface IDocumentStatus {
  code?: string | undefined;
  description?: string | undefined;
}

export class Email implements IEmail {
  eMail!: string;
  type?: ContactType;

  constructor(data?: IEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eMail = _data["eMail"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): Email {
    data = typeof data === 'object' ? data : {};
    let result = new Email();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eMail"] = this.eMail;
    data["type"] = this.type;
    return data;
  }
}

export interface IEmail {
  eMail: string;
  type?: ContactType;
}

export enum CommunicationChannelType {
  Post = "Post",
  Email = "Email",
  Phone = "Phone",
  MobilePhone = "MobilePhone",
  Fax = "Fax",
  SMS = "SMS",
  WhatsApp = "WhatsApp",
  FbMessenger = "FbMessenger",
  WeChat = "WeChat",
}

export enum ContactType {
  Private = "Private",
  Business = "Business",
}

export enum PhoneNumberType {
  Mobile = "Mobile",
  Business = "Business",
}

export class ObjectType implements IObjectType {
  id!: string;
  code?: string | undefined;
  description?: string | undefined;

  constructor(data?: IObjectType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ObjectType {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface IObjectType {
  id: string;
  code?: string | undefined;
  description?: string | undefined;
}

export class PhoneNumber implements IPhoneNumber {
  phoneNo?: string | undefined;
  type?: PhoneNumberType;

  constructor(data?: IPhoneNumber) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.phoneNo = _data["phoneNo"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): PhoneNumber {
    data = typeof data === 'object' ? data : {};
    let result = new PhoneNumber();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["phoneNo"] = this.phoneNo;
    data["type"] = this.type;
    return data;
  }
}

export interface IPhoneNumber {
  phoneNo?: string | undefined;
  type?: PhoneNumberType;
}

export class Price implements IPrice {
  grossPrice?: number | undefined;
  netPrice?: number | undefined;
  currency?: string | undefined;
  discount?: Discount;
  taxes?: PriceTaxes[] | undefined;

  constructor(data?: IPrice) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.grossPrice = _data["grossPrice"];
      this.netPrice = _data["netPrice"];
      this.currency = _data["currency"];
      this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
      if (Array.isArray(_data["taxes"])) {
        this.taxes = [] as any;
        for (let item of _data["taxes"])
          this.taxes!.push(PriceTaxes.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Price {
    data = typeof data === 'object' ? data : {};
    let result = new Price();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["grossPrice"] = this.grossPrice;
    data["netPrice"] = this.netPrice;
    data["currency"] = this.currency;
    data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
    if (Array.isArray(this.taxes)) {
      data["taxes"] = [];
      for (let item of this.taxes)
        data["taxes"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPrice {
  grossPrice?: number | undefined;
  netPrice?: number | undefined;
  currency?: string | undefined;
  discount?: Discount;
  taxes?: PriceTaxes[] | undefined;
}

export class PriceTaxes implements IPriceTaxes {
  type?: PriceTaxesType;
  value?: number | undefined;
  percent?: number | undefined;

  constructor(data?: IPriceTaxes) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.value = _data["value"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): PriceTaxes {
    data = typeof data === 'object' ? data : {};
    let result = new PriceTaxes();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["value"] = this.value;
    data["percent"] = this.percent;
    return data;
  }
}

export interface IPriceTaxes {
  type?: PriceTaxesType;
  value?: number | undefined;
  percent?: number | undefined;
}

export class ServiceJob implements IServiceJob {
  id!: string;
  description?: string | undefined;
  descriptionLong?: string | undefined;
  price?: Price;
  billToCustomerName?: string | undefined;

  constructor(data?: IServiceJob) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.description = _data["description"];
      this.descriptionLong = _data["descriptionLong"];
      this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
      this.billToCustomerName = _data["billToCustomerName"];
    }
  }

  static fromJS(data: any): ServiceJob {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceJob();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["description"] = this.description;
    data["descriptionLong"] = this.descriptionLong;
    data["price"] = this.price ? this.price.toJSON() : <any>undefined;
    data["billToCustomerName"] = this.billToCustomerName;
    return data;
  }
}

export interface IServiceJob {
  id: string;
  description?: string | undefined;
  descriptionLong?: string | undefined;
  price?: Price;
  billToCustomerName?: string | undefined;
}

export class ServiceLine implements IServiceLine {
  jobId?: string | undefined;
  type?: string | undefined;
  no?: string | undefined;
  description?: string | undefined;
  quantity?: number | undefined;
  unitOfMeasure?: string | undefined;

  constructor(data?: IServiceLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"];
      this.type = _data["type"];
      this.no = _data["no"];
      this.description = _data["description"];
      this.quantity = _data["quantity"];
      this.unitOfMeasure = _data["unitOfMeasure"];
    }
  }

  static fromJS(data: any): ServiceLine {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId;
    data["type"] = this.type;
    data["no"] = this.no;
    data["description"] = this.description;
    data["quantity"] = this.quantity;
    data["unitOfMeasure"] = this.unitOfMeasure;
    return data;
  }
}

export interface IServiceLine {
  jobId?: string | undefined;
  type?: string | undefined;
  no?: string | undefined;
  description?: string | undefined;
  quantity?: number | undefined;
  unitOfMeasure?: string | undefined;
}

export class User implements IUser {
  id!: string;
  name?: string | undefined;

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): User {
    data = typeof data === 'object' ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IUser {
  id: string;
  name?: string | undefined;
}

export class Vehicle implements IVehicle {
  vin?: string | undefined;
  vin2?: string | undefined;
  licenseNo?: string | undefined;
  make?: string | undefined;
  department?: string | undefined;
  mileage?: number | undefined;
  model?: string | undefined;

  constructor(data?: IVehicle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vin = _data["vin"];
      this.vin2 = _data["vin2"];
      this.licenseNo = _data["licenseNo"];
      this.make = _data["make"];
      this.department = _data["department"];
      this.mileage = _data["mileage"];
      this.model = _data["model"];
    }
  }

  static fromJS(data: any): Vehicle {
    data = typeof data === 'object' ? data : {};
    let result = new Vehicle();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["vin"] = this.vin;
    data["vin2"] = this.vin2;
    data["licenseNo"] = this.licenseNo;
    data["make"] = this.make;
    data["department"] = this.department;
    data["mileage"] = this.mileage;
    data["model"] = this.model;
    return data;
  }
}

export interface IVehicle {
  vin?: string | undefined;
  vin2?: string | undefined;
  licenseNo?: string | undefined;
  make?: string | undefined;
  department?: string | undefined;
  mileage?: number | undefined;
  model?: string | undefined;
}

export class AppointmentDetails implements IAppointmentDetails {
  id?: string | undefined;
  documentNo?: string | undefined;
  locationId?: string | undefined;
  appointmentDate?: string | undefined;
  serviceAdvisor?: User;
  pickupDate?: string | undefined;
  pickupServiceAdvisor?: User;
  serviceJobs?: ServiceJob[] | undefined;
  serviceLines?: ServiceLine[] | undefined;
  vehicle?: OABVehicle;
  customerId?: string | undefined;
  documentStatus?: DocumentStatus;
  services?: Service[] | undefined;

  constructor(data?: IAppointmentDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.documentNo = _data["documentNo"];
      this.locationId = _data["locationId"];
      this.appointmentDate = _data["appointmentDate"];
      this.serviceAdvisor = _data["serviceAdvisor"] ? User.fromJS(_data["serviceAdvisor"]) : <any>undefined;
      this.pickupDate = _data["pickupDate"];
      this.pickupServiceAdvisor = _data["pickupServiceAdvisor"] ? User.fromJS(_data["pickupServiceAdvisor"]) : <any>undefined;
      if (Array.isArray(_data["serviceJobs"])) {
        this.serviceJobs = [] as any;
        for (let item of _data["serviceJobs"])
          this.serviceJobs!.push(ServiceJob.fromJS(item));
      }
      if (Array.isArray(_data["serviceLines"])) {
        this.serviceLines = [] as any;
        for (let item of _data["serviceLines"])
          this.serviceLines!.push(ServiceLine.fromJS(item));
      }
      this.vehicle = _data["vehicle"] ? OABVehicle.fromJS(_data["vehicle"]) : <any>undefined;
      this.customerId = _data["customerId"];
      this.documentStatus = _data["documentStatus"] ? DocumentStatus.fromJS(_data["documentStatus"]) : <any>undefined;
      if (Array.isArray(_data["services"])) {
        this.services = [] as any;
        for (let item of _data["services"])
          this.services!.push(Service.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppointmentDetails {
    data = typeof data === 'object' ? data : {};
    let result = new AppointmentDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["documentNo"] = this.documentNo;
    data["locationId"] = this.locationId;
    data["appointmentDate"] = this.appointmentDate;
    data["serviceAdvisor"] = this.serviceAdvisor ? this.serviceAdvisor.toJSON() : <any>undefined;
    data["pickupDate"] = this.pickupDate;
    data["pickupServiceAdvisor"] = this.pickupServiceAdvisor ? this.pickupServiceAdvisor.toJSON() : <any>undefined;
    if (Array.isArray(this.serviceJobs)) {
      data["serviceJobs"] = [];
      for (let item of this.serviceJobs)
        data["serviceJobs"].push(item.toJSON());
    }
    if (Array.isArray(this.serviceLines)) {
      data["serviceLines"] = [];
      for (let item of this.serviceLines)
        data["serviceLines"].push(item.toJSON());
    }
    data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
    data["customerId"] = this.customerId;
    data["documentStatus"] = this.documentStatus ? this.documentStatus.toJSON() : <any>undefined;
    if (Array.isArray(this.services)) {
      data["services"] = [];
      for (let item of this.services)
        data["services"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppointmentDetails {
  id?: string | undefined;
  documentNo?: string | undefined;
  locationId?: string | undefined;
  appointmentDate?: string | undefined;
  serviceAdvisor?: User;
  pickupDate?: string | undefined;
  pickupServiceAdvisor?: User;
  serviceJobs?: ServiceJob[] | undefined;
  serviceLines?: ServiceLine[] | undefined;
  vehicle?: OABVehicle;
  customerId?: string | undefined;
  documentStatus?: DocumentStatus;
  services?: Service[] | undefined;
}

export enum PriceTaxesType {
  Vat = "Vat",
  Gst = "Gst",
}

export enum ResourceType {
  ServiceAdvisor = "ServiceAdvisor",
  MobilityVehicle = "MobilityVehicle",
}

export enum ServiceType {
  Main = "Main",
  Upsell = "Upsell",
  Mobility = "Mobility",
}

export class OABVehicle implements IOABVehicle {
  id!: string;
  vin?: string | undefined;
  vin2?: string | undefined;
  licenseNo?: string | undefined;
  make?: string | undefined;
  model?: string | undefined;
  modelYear?: number | undefined;
  color?: string | undefined;
  mileage?: number | undefined;
  initialRegistrationDate?: Date | undefined;
  nextGeneralInspectionDate?: Date | undefined;
  lastVisitDate?: Date | undefined;

  constructor(data?: IOABVehicle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.vin = _data["vin"];
      this.vin2 = _data["vin2"];
      this.licenseNo = _data["licenseNo"];
      this.make = _data["make"];
      this.model = _data["model"];
      this.modelYear = _data["modelYear"];
      this.color = _data["color"];
      this.mileage = _data["mileage"];
      this.initialRegistrationDate = _data["initialRegistrationDate"] ? new Date(_data["initialRegistrationDate"].toString()) : <any>undefined;
      this.nextGeneralInspectionDate = _data["nextGeneralInspectionDate"] ? new Date(_data["nextGeneralInspectionDate"].toString()) : <any>undefined;
      this.lastVisitDate = _data["lastVisitDate"] ? new Date(_data["lastVisitDate"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): OABVehicle {
    data = typeof data === 'object' ? data : {};
    let result = new OABVehicle();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["vin"] = this.vin;
    data["vin2"] = this.vin2;
    data["licenseNo"] = this.licenseNo;
    data["make"] = this.make;
    data["model"] = this.model;
    data["modelYear"] = this.modelYear;
    data["color"] = this.color;
    data["mileage"] = this.mileage;
    data["initialRegistrationDate"] = this.initialRegistrationDate ? this.initialRegistrationDate.toISOString() : <any>undefined;
    data["nextGeneralInspectionDate"] = this.nextGeneralInspectionDate ? this.nextGeneralInspectionDate.toISOString() : <any>undefined;
    data["lastVisitDate"] = this.lastVisitDate ? this.lastVisitDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IOABVehicle {
  id: string;
  vin?: string | undefined;
  vin2?: string | undefined;
  licenseNo?: string | undefined;
  make?: string | undefined;
  model?: string | undefined;
  modelYear?: number | undefined;
  color?: string | undefined;
  mileage?: number | undefined;
  initialRegistrationDate?: Date | undefined;
  nextGeneralInspectionDate?: Date | undefined;
  lastVisitDate?: Date | undefined;
}

export class AppointmentRequest implements IAppointmentRequest {
  locationId!: string;
  vehicle?: Vehicle;
  customer?: Customer;
  timeslotFrom?: string;
  preferredPaymentMethod?: string | undefined;
  comment?: string | undefined;
  resourceIds?: string[] | undefined;
  services?: Service[] | undefined;
  dataPrivacyConsent?: DataPrivacyConsent[] | undefined;

  constructor(data?: IAppointmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationId = _data["locationId"];
      this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
      this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
      this.timeslotFrom = _data["timeslotFrom"] ? new Date(_data["timeslotFrom"].toString()) : <any>undefined;
      this.preferredPaymentMethod = _data["preferredPaymentMethod"];
      this.comment = _data["comment"];
      if (Array.isArray(_data["resourceIds"])) {
        this.resourceIds = [] as any;
        for (let item of _data["resourceIds"])
          this.resourceIds!.push(item);
      }
      if (Array.isArray(_data["services"])) {
        this.services = [] as any;
        for (let item of _data["services"])
          this.services!.push(Service.fromJS(item));
      }
      if (Array.isArray(_data["dataPrivacyConsent"])) {
        this.dataPrivacyConsent = [] as any;
        for (let item of _data["dataPrivacyConsent"])
          this.dataPrivacyConsent!.push(DataPrivacyConsent.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppointmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AppointmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["locationId"] = this.locationId;
    data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
    data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
    data["timeslotFrom"] = this.timeslotFrom ? this.timeslotFrom.toString() : <any>undefined;
    data["preferredPaymentMethod"] = this.preferredPaymentMethod;
    data["comment"] = this.comment;
    if (Array.isArray(this.resourceIds)) {
      data["resourceIds"] = [];
      for (let item of this.resourceIds)
        data["resourceIds"].push(item);
    }
    if (Array.isArray(this.services)) {
      data["services"] = [];
      for (let item of this.services)
        data["services"].push(item.toJSON());
    }
    if (Array.isArray(this.dataPrivacyConsent)) {
      data["dataPrivacyConsent"] = [];
      for (let item of this.dataPrivacyConsent)
        data["dataPrivacyConsent"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppointmentRequest {
  locationId: string;
  vehicle?: Vehicle;
  customer?: Customer;
  timeslotFrom?: string;
  preferredPaymentMethod?: string | undefined;
  comment?: string | undefined;
  resourceIds?: string[] | undefined;
  services?: Service[] | undefined;
  dataPrivacyConsent?: DataPrivacyConsent[] | undefined;
}

export class TimeslotRequest implements ITimeslotRequest {
  dateFrom!: Date;
  dateTo!: Date;
  resourceIds?: string[] | undefined;
  services?: Service[] | undefined;

  constructor(data?: ITimeslotRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
      this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
      if (Array.isArray(_data["resourceIds"])) {
        this.resourceIds = [] as any;
        for (let item of _data["resourceIds"])
          this.resourceIds!.push(item);
      }
      if (Array.isArray(_data["services"])) {
        this.services = [] as any;
        for (let item of _data["services"])
          this.services!.push(Service.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TimeslotRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TimeslotRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
    data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
    if (Array.isArray(this.resourceIds)) {
      data["resourceIds"] = [];
      for (let item of this.resourceIds)
        data["resourceIds"].push(item);
    }
    if (Array.isArray(this.services)) {
      data["services"] = [];
      for (let item of this.services)
        data["services"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITimeslotRequest {
  dateFrom: Date;
  dateTo: Date;
  resourceIds?: string[] | undefined;
  services?: Service[] | undefined;
}

export class Resource implements IResource {
  id!: string;
  code?: string | undefined;
  description?: string | undefined;
  type!: ResourceType;
  department?: string | undefined;

  constructor(data?: IResource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
      this.type = _data["type"];
      this.department = _data["department"];
    }
  }

  static fromJS(data: any): Resource {
    data = typeof data === 'object' ? data : {};
    let result = new Resource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    data["type"] = this.type;
    data["department"] = this.department;
    return data;
  }
}

export interface IResource {
  id: string;
  code?: string | undefined;
  description?: string | undefined;
  type: ResourceType;
  department?: string | undefined;
}

export class PaymentMethodsResponse implements IPaymentMethodsResponse {
  contentLanguage?: string | undefined;
  paymentMethods!: ObjectType[];

  constructor(data?: IPaymentMethodsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.paymentMethods = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentLanguage = _data["contentLanguage"];
      if (Array.isArray(_data["paymentMethods"])) {
        this.paymentMethods = [] as any;
        for (let item of _data["paymentMethods"])
          this.paymentMethods!.push(ObjectType.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PaymentMethodsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PaymentMethodsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["contentLanguage"] = this.contentLanguage;
    if (Array.isArray(this.paymentMethods)) {
      data["paymentMethods"] = [];
      for (let item of this.paymentMethods)
        data["paymentMethods"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPaymentMethodsResponse {
  contentLanguage?: string | undefined;
  paymentMethods: ObjectType[];
}

export class Service implements IService {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
  name?: string | undefined;
  descriptionLong?: string | undefined;
  note?: string | undefined;
  type?: ServiceType;
  department?: string | undefined;
  category?: string | undefined;
  origin?: string | undefined;
  duration?: string | undefined;
  unitPrice?: Price;

  constructor(data?: IService) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
      this.name = _data["name"];
      this.descriptionLong = _data["descriptionLong"];
      this.note = _data["note"];
      this.type = _data["type"];
      this.department = _data["department"];
      this.category = _data["category"];
      this.origin = _data["origin"];
      this.duration = _data["duration"];
      this.unitPrice = _data["unitPrice"] ? Price.fromJS(_data["unitPrice"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Service {
    data = typeof data === 'object' ? data : {};
    let result = new Service();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    data["name"] = this.name;
    data["descriptionLong"] = this.descriptionLong;
    data["note"] = this.note;
    data["type"] = this.type;
    data["department"] = this.department;
    data["category"] = this.category;
    data["origin"] = this.origin;
    data["duration"] = this.duration;
    data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>undefined;
    return data;
  }
}

export interface IService {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
  name?: string | undefined;
  descriptionLong?: string | undefined;
  note?: string | undefined;
  type?: ServiceType;
  department?: string | undefined;
  category?: string | undefined;
  origin?: string | undefined;
  duration?: string | undefined;
  unitPrice?: Price;
}

export class Timeslot implements ITimeslot {
  id!: string;
  from?: Date;
  fromUtcOffset?: string | undefined;
  to?: Date;
  toUtcOffset?: string | undefined;

  constructor(data?: ITimeslot) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
      this.fromUtcOffset = _data["fromUtcOffset"];
      this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
      this.toUtcOffset = _data["toUtcOffset"];
    }
  }

  static fromJS(data: any): Timeslot {
    data = typeof data === 'object' ? data : {};
    let result = new Timeslot();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["from"] = this.from ? this.from.toISOString() : <any>undefined;
    data["fromUtcOffset"] = this.fromUtcOffset;
    data["to"] = this.to ? this.to.toISOString() : <any>undefined;
    data["toUtcOffset"] = this.toUtcOffset;
    return data;
  }
}

export interface ITimeslot {
  id: string;
  from?: Date;
  fromUtcOffset?: string | undefined;
  to?: Date;
  toUtcOffset?: string | undefined;
}

export class DmsProblemDetails implements IDmsProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  code?: number;
  messageId?: string | undefined;

  [key: string]: any;

  constructor(data?: IDmsProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
      this.code = _data["code"];
      this.messageId = _data["messageId"];
    }
  }

  static fromJS(data: any): DmsProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new DmsProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    data["code"] = this.code;
    data["messageId"] = this.messageId;
    return data;
  }
}

export interface IDmsProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  code?: number;
  messageId?: string | undefined;

  [key: string]: any;
}

export class AddressDto implements IAddressDto {
  type?: AddressTypeDto;
  postalCode?: string | undefined;
  street?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  geoLatitude?: number | undefined;
  geoLongitude?: number | undefined;

  constructor(data?: IAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.postalCode = _data["postalCode"];
      this.street = _data["street"];
      this.city = _data["city"];
      this.country = _data["country"];
      this.geoLatitude = _data["geoLatitude"];
      this.geoLongitude = _data["geoLongitude"];
    }
  }

  static fromJS(data: any): AddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["postalCode"] = this.postalCode;
    data["street"] = this.street;
    data["city"] = this.city;
    data["country"] = this.country;
    data["geoLatitude"] = this.geoLatitude;
    data["geoLongitude"] = this.geoLongitude;
    return data;
  }
}

export interface IAddressDto {
  type?: AddressTypeDto;
  postalCode?: string | undefined;
  street?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  geoLatitude?: number | undefined;
  geoLongitude?: number | undefined;
}

export class CompanyDto implements ICompanyDto {
  id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  locations?: LocationDto[] | undefined;

  constructor(data?: ICompanyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["locations"])) {
        this.locations = [] as any;
        for (let item of _data["locations"])
          this.locations!.push(LocationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompanyDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.locations)) {
      data["locations"] = [];
      for (let item of this.locations)
        data["locations"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICompanyDto {
  id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  locations?: LocationDto[] | undefined;
}

export class DepartmentDto implements IDepartmentDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;

  constructor(data?: IDepartmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): DepartmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new DepartmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface IDepartmentDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
}

export enum AddressTypeDto {
  Business = "Business",
  Private = "Private",
}

export class LocationDto implements ILocationDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
  address?: AddressDto;

  constructor(data?: ILocationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
      this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
    }
  }

  static fromJS(data: any): LocationDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    return data;
  }
}

export interface ILocationDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
  address?: AddressDto;
}

export class LoginResponse implements ILoginResponse {
  session?: SessionDto;
  companies?: CompanyDto;

  constructor(data?: ILoginResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.session = _data["session"] ? SessionDto.fromJS(_data["session"]) : <any>undefined;
      this.companies = _data["companies"] ? CompanyDto.fromJS(_data["companies"]) : <any>undefined;
    }
  }

  static fromJS(data: any): LoginResponse {
    data = typeof data === 'object' ? data : {};
    let result = new LoginResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["session"] = this.session ? this.session.toJSON() : <any>undefined;
    data["companies"] = this.companies ? this.companies.toJSON() : <any>undefined;
    return data;
  }
}

export interface ILoginResponse {
  session?: SessionDto;
  companies?: CompanyDto;
}

export class MakeDto implements IMakeDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;

  constructor(data?: IMakeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): MakeDto {
    data = typeof data === 'object' ? data : {};
    let result = new MakeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface IMakeDto {
  id?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
}

export class SessionDto implements ISessionDto {
  token?: string | undefined;
  expiresOn?: Date;
  backendCode?: string | undefined;
  appointmentId?: string | undefined;

  constructor(data?: ISessionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
      this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
      this.backendCode = _data["backendCode"];
      this.appointmentId = _data["appointmentId"];
    }
  }

  static fromJS(data: any): SessionDto {
    data = typeof data === 'object' ? data : {};
    let result = new SessionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["token"] = this.token;
    data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
    data["backendCode"] = this.backendCode;
    data["appointmentId"] = this.appointmentId;
    return data;
  }
}

export interface ISessionDto {
  token?: string | undefined;
  expiresOn?: Date;
  backendCode?: string | undefined;
  appointmentId?: string | undefined;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}